import React from "react";
import SbEditable from "storyblok-react";
import { PricingExplorerProvider } from "./PricingExplorerContext";
import { BillingToggle } from "./BillingToggle";
import { CoachingScale } from "./CoachingScale";
import { PlanCards } from "./PlanCards";
import styles from "./pricing-explorer.module.scss";
import type { PricingExplorerStoryblok } from "./types";

interface Props {
  blok: PricingExplorerStoryblok;
}

const PricingExplorer = ({ blok }: Props) => {
  const plans = blok.plans || [];
  const highlightedIndex = plans.findIndex((p) => p.highlight);
  const defaultSelectedPlan = highlightedIndex >= 0 ? highlightedIndex : 0;

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <PricingExplorerProvider
        defaultBillingPeriod={blok.default_billing || "monthly"}
        defaultSelectedPlanIndex={defaultSelectedPlan}
        planCount={plans.length}
      >
        <div className={styles.pricingExplorer}>
          <div className={styles.pricingExplorerControls}>
            <BillingToggle />
            {blok.show_coaching_scale ? (
              <CoachingScale
                labelStart={blok.scale_label_start}
                labelEnd={blok.scale_label_end}
              />
            ) : null}
          </div>
          <PlanCards plans={plans} variant={blok.variant || "compact"} />
        </div>
      </PricingExplorerProvider>
    </SbEditable>
  );
};

export default PricingExplorer;
